import React, { useState } from 'react';
import { Spin, Form, Select, Alert } from 'antd';
import { executorsQuery, useSubmit } from '../../../../api';
import BaseModal from '../../../BaseModal/BaseModal';
import FetchError from '../../../FetchError/FetchError';
import { fieldNames } from './constants';
import { useSetModalVisible } from '../../../../model/modalState';
import { dspxGetWorkerChildrens } from '../../../../../../../../helpers/dspx-utils';
import InformationBlockModal from '../../../InformationBlockModal/InformationBlockModal';
import { typeMassActionsText } from '../../../InformationBlockModal/constants';

const { useFetch: useExecutors } = executorsQuery;
const { Item: FormItem, create: createForm } = Form;

const ErrorContent = ({ refetch }) => {
  return (
    <FetchError
      msg="Не удалось получить список исполнителей"
      onClick={() => refetch()}
    />
  );
};

const FormContainer = ({form,  requests, onSuccess }) => {
  const { getFieldDecorator, validateFields, resetFields } = form;

  const { data, isFetching, refetch } = useExecutors({
    staleTime: Infinity,
    notifyOnChangeProps: ['data', 'isFetching'],
  });

  const { submitAsync, loading } = useSubmit({
      url: 'Request/set_executer',
      errMsg: 'Не удалось изменить исполнителя у выбранных заявок',
      onSuccess,
    });

  const isError = data === 'Error';

  const setModalVisible = useSetModalVisible();
  const [stateInfo, setStateInfo] = useState(false);
  const [value, setValue] = useState(null)

  const handleSubmit = (e) => {
          e.preventDefault();

          validateFields((err, values) => {
            if (!err) {
              const value = {
                ExecuterId: values.executor
              };

              setValue(value);
              setStateInfo(true);
            }
          });
        };
    
  const handleConfirmSubmit = async (e) => {
    e.preventDefault();

    try {
      await submitAsync({
        ids: requests.map(({ id }) => id),
        value,
        requests,
      });

      setModalVisible(false);
      setStateInfo(false);
      resetFields();
    } catch(error) {
      return <Alert title={error.message} />
    }
  }

  const cancelSubmit = () => {
    setStateInfo(false);
    resetFields()
  }

  return (
    <BaseModal
      title={stateInfo ? "Подтвердите изменения" : "Изменение исполнителя"}
      okButtonProps={{ disabled: isFetching }}
      footer={isError ? null : undefined}
      onOk={stateInfo ? handleConfirmSubmit : handleSubmit}
      onCancel={cancelSubmit}
      confirmLoading={loading}
      width={stateInfo ? 600 : 450}
    >
      <Spin spinning={Boolean(isFetching)}>
        {isError ? (
          <ErrorContent refetch={refetch} />
        ) : (
        !stateInfo ? (
         <Form>
          <FormItem label="Исполнитель">
            {getFieldDecorator(fieldNames.executor, {
              rules: [
                {
                  required: true,
                  message: 'Выберите исполнителя',
                },
              ],
            })(
              <Select
                showSearch
                optionLabelProp="label"
                optionFilterProp="searchtext"
                placeholder="Выберите исполнителя"
              >
                {dspxGetWorkerChildrens(data, undefined, true)}
              </Select>
            )}
          </FormItem>
        </Form>
        ) : (
          <InformationBlockModal typeMassActions={typeMassActionsText.exucutor} count={requests.length} />
        )
        )}
      </Spin>
    </BaseModal>
  );
};

const ChangeExecutor = createForm({ name: 'mass_actions_executor' })(
  FormContainer
);

export default ChangeExecutor;
